const dashboard = {
  "social.description.1":
    "Next-gen gaming metaverse. Create, play, & learn with others globally.",
  "social.description.2":
    "Follow our Twitter account for latest news and announcement.",
  "social.follow": "Follow",
};
export default dashboard;
